import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import { graphql, useFragment } from 'react-relay';
import { MoreSurveysBanner_profileUrlRef$key } from './__generated__/MoreSurveysBanner_profileUrlRef.graphql';
import Icon from './assets/more-about-you.svg';
import classes from './MoreSurveysBanner.module.scss';

export type Props = { profileUrlRef: MoreSurveysBanner_profileUrlRef$key; className: string };

export default function MoreSurveysBanner({ profileUrlRef, className }: Props) {
  const data = useFragment<MoreSurveysBanner_profileUrlRef$key>(
    graphql`
      fragment MoreSurveysBanner_profileUrlRef on Query {
        endlessProfilerUrl
      }
    `,
    profileUrlRef,
  );

  return data.endlessProfilerUrl ? (
    <Card className={clsx(classes.root, className)}>
      <A href={data.endlessProfilerUrl} className={classes.innerLink}>
        <Icon className={classes.iconImage} />
        <Txt className={classes.text}>More about you</Txt>
        <Txt className={classes.earn}>
          <span>Earn</span>Lifepoints
        </Txt>
      </A>
    </Card>
  ) : null;
}
